// Generated by CoffeeScript 2.7.0
var CollaboratorsSelection;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import UserItem from 'trunks/vue/admin/components/libs/user_item.js';

import CollaboratorsSelect from 'trunks/vue/admin/compositions/collaborators_select.js';

export default CollaboratorsSelection = Vue.extend({
  components: {
    'collaborators-select': CollaboratorsSelect,
    'user-item': UserItem,
    popover: Popover
  },
  props: {
    initialCollaboratorIds: {
      type: Array,
      default: function() {
        return [];
      }
    },
    extendClass: String,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      collaborators: []
    };
  },
  template: `<div :class='extendClass'>
  <div class='collaborators-wrapper'>
    <user-item v-for='collaborator in collaborators'
               :key='collaborator.id'
               :user='collaborator'
               :vertical='true'
               :removable='!readonly'
               @removed='collaboratorRemovedFunc' />
  </div>
  <popover v-if='!readonly'
           :caret='false'
           position='bottom left'
           size='default'
           type='select'
           @beforeClose='resetCollaboratorsSelect'
           ref='collaboratorSelectPopoverRef' >
    <template slot='trigger'>
      <div class='btn btn-default'>
        <span>添加人员</span>
        <i class='slp-search'></i>
      </div>
    </template>
    <template slot='content'>
      <collaborators-select :initialSelectedCollaboratorIds='selectedCollaboratorIds'
                            :storeCollaboratorInstances='true'
                            @cancelClicked='collaboratorsSelectCanceledFunc'
                            @submitClicked='collaboratorsSelectSubmitedFunc'
                            ref='collaboratorsSelectRef' />
    </template>
  </popover>
</div>`,
  computed: {
    selectedCollaboratorIds: function() {
      return _.pluck(this.collaborators, 'id');
    }
  },
  created: function() {
    if (!_.isBlank(this.initialCollaboratorIds)) {
      return new Skylark.Libs.PaginatedResources(Skylark.Helpers.UrlHelper.adminUrlFor('users'), {
        params: {
          ids: this.initialCollaboratorIds
        },
        callback: (data) => {
          return this.collaborators = this.collaborators.concat(data);
        },
        completedCallback: () => {
          return this.$emit('valueChanged', this.selectedCollaboratorIds);
        }
      });
    }
  },
  methods: {
    collaboratorRemovedFunc: function(collaborator) {
      this.collaborators = _.reject(this.collaborators, function(user) {
        return user.id === collaborator.id;
      });
      return this.$emit('valueChanged', this.selectedCollaboratorIds);
    },
    collaboratorsSelectCanceledFunc: function() {
      return this.$refs.collaboratorSelectPopoverRef.close();
    },
    collaboratorsSelectSubmitedFunc: function() {
      this.collaborators = _.clone(this.$refs.collaboratorsSelectRef.selectedCollaborators);
      this.$emit('valueChanged', this.selectedCollaboratorIds);
      return this.$refs.collaboratorSelectPopoverRef.close();
    },
    resetCollaboratorsSelect: function() {
      return this.$refs.collaboratorsSelectRef.reset();
    }
  }
});
